<template>
  <WidgetKpiCard
    :error="!!error"
    :loading="loading"
    :lastUpdate="lastUpdate"
    @click:refresh="refresh"
    @click:table="showTable"
  >
    <template #title>
      {{ $t("widgets.delivery_rate.title") }}
    </template>

    <template v-if="data" #main>
      <KpiMain
        :title="dateNames.month"
        :value="Math.round(data.main.value) + '%'"
        :delta="data.main.delta"
      ></KpiMain>
    </template>

    <template v-if="data" #subs>
      <KpiSub
        :title="$t('widgets.common.today')"
        :value="Math.round(data.subs.day.value)"
        :format="v => v + '%'"
        :delta="data.subs.day.delta"
      ></KpiSub>
      <KpiSub
        :title="$t('widgets.common.week')"
        :value="Math.round(data.subs.week.value)"
        :format="v => v + '%'"
        :delta="data.subs.week.delta"
      ></KpiSub>
      <KpiSub
        :title="$t('widgets.delivery_rate.pending')"
        :value="data.subs.to_deliver"
      ></KpiSub>
    </template>
  </WidgetKpiCard>
</template>

<script>
import WidgetKpiCard from "./WidgetKpiCard.vue";
import KpiSub from "./WidgetKpiCard/KpiSub.vue";
import KpiMain from "./WidgetKpiCard/KpiMain.vue";

import { useWidgetApi } from "@/composables/api/widget";
import { useRouter } from "@/composables/router";
import { usePeriodNames } from "@/composables/date";

export default {
  components: { WidgetKpiCard, KpiSub, KpiMain },

  props: {
    hover: {
      type: Boolean,
      default: false
    }
  },

  setup() {
    const { data, lastUpdate, loading, error, execute } = useWidgetApi(
      "/dashboard/delivery_rate"
    );

    const router = useRouter();

    const showTable = () => {
      router.push({
        name: "DashboardTable",
        query: { measure: "delivery_rate" }
      });
    };

    const dateNames = usePeriodNames();

    return {
      data,
      loading,
      error,
      lastUpdate,
      dateNames,

      refresh: execute,
      showTable
    };
  }
};
</script>
<style></style>
